import { render, staticRenderFns } from "./LegalBasisValidationsModal.vue?vue&type=template&id=8dbc1ce4&"
import script from "./LegalBasisValidationsModal.vue?vue&type=script&lang=js&"
export * from "./LegalBasisValidationsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports